import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['hiddenInput', 'rulesContainer', 'ruleRow', 'typeSelect', 'valueInput']

  addRule() {
    const row = this.buildRuleRow('overdue_days', '')
    this.rulesContainerTarget.insertAdjacentHTML('beforeend', row)
    this.serialize()
  }

  removeRule(event) {
    event.currentTarget.closest('.rule-row').remove()
    this.serialize()
  }

  typeChanged(event) {
    const row = event.currentTarget.closest('.rule-row')
    const type = event.currentTarget.value
    const oldInput = row.querySelector('[data-billing-blocking-rules-target="valueInput"]')
    const newInput = this.buildValueInput(type, '')
    oldInput.outerHTML = newInput
    this.serialize()
  }

  serialize() {
    const rules = []
    this.ruleRowTargets.forEach(row => {
      const type = row.querySelector('[data-billing-blocking-rules-target="typeSelect"]')?.value
      const value = row.querySelector('[data-billing-blocking-rules-target="valueInput"]')?.value
      if (type && value) {
        rules.push({ type, value: type === 'overdue_days' ? parseInt(value, 10) : value })
      }
    })
    this.hiddenInputTarget.value = JSON.stringify(rules)
  }

  buildRuleRow(type, value) {
    return `
      <div class="flex items-center gap-2 rule-row" data-billing-blocking-rules-target="ruleRow">
        <select class="select select-bordered h-10 min-h-10 text-sm"
                data-action="change->billing-blocking-rules#typeChanged"
                data-billing-blocking-rules-target="typeSelect">
          <option value="overdue_days" ${type === 'overdue_days' ? 'selected' : ''}>Dias de atraso maior que</option>
          <option value="billing_status" ${type === 'billing_status' ? 'selected' : ''}>Status do boleto</option>
        </select>
        ${this.buildValueInput(type, value)}
        <button type="button"
                class="text-gray-400 hover:text-red-500 transition-colors"
                data-action="billing-blocking-rules#removeRule">&times;</button>
      </div>
    `
  }

  buildValueInput(type, value) {
    if (type === 'billing_status') {
      return `<input type="text" value="${value}" placeholder="Codigo do ERP"
                     class="input input-bordered w-32 h-10 min-h-10 text-sm"
                     data-billing-blocking-rules-target="valueInput"
                     data-action="input->billing-blocking-rules#serialize">`
    }
    return `<input type="number" value="${value}" min="1" placeholder="Dias"
                   class="input input-bordered w-24 h-10 min-h-10 text-sm"
                   data-billing-blocking-rules-target="valueInput"
                   data-action="input->billing-blocking-rules#serialize">`
  }
}
